import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { appendModel } from '../../../../features/site/siteSlice'
import { oauthConsts, OVERRIDE_ID_FB } from '../../../utils/common'

const INITIAL_STATE = {
    account: {}
}

function FacebookAds(props){
    const oauthConst = oauthConsts()

    const dispatch = useDispatch()
    const [state, setState] = useState(INITIAL_STATE)

    const isAdmin = useSelector(state => state.session.isAdmin)
    const model = useSelector(state => state.site.model)
    const oauthTokens = useSelector(state => state.session.oauthTokens)
    
    const AddAccParent = (p) => props.design === "onboarding" ? <div className="text-center">
        {p.children}
    </div> : <>{p.children}</>

    useEffect(() => {
        if(state.account !== INITIAL_STATE.account){

            let { account } = state 
            const map = {
                tokenId: oauthTokens.fb?.id,
                accountName: account.name,
                adAccId: account.id
            }
            
            let sForm = {
                ...model.siteForm,
                attr: {
                    ...model.siteForm.attr,
                    accounts: {
                        ...(model.siteForm.attr.accounts ? model.siteForm.attr.accounts : []),
                        fb: map
                    }
                }
            }

            localStorage.setItem("fbSelection", JSON.stringify({
                account: account.id,
                accountKey: account.key,
                map: JSON.stringify({...map})
            }))

            dispatch(appendModel({siteForm: sForm}))
            props.onSelectionUpdated("fb")
        }
    }, [state.account])
    
    const { siteForm, sites, siteActiveIdx } = model
    const { account } = state

    const hrefOauth = `${oauthConst.fbAuthURL}&state=${props.design === "onboarding" ? "/onboarding/": "/admin/"}${siteForm.siteId}/fb`
    const site = sites[siteActiveIdx]

    return <>
        <div className="d-flex justify-content-end mb-3">
            <div className="btn-group">
                <a href={hrefOauth} className="btn btn-lg btn-info">
                    <i class="fas fa-sync-alt"></i> Refresh
                </a>
            </div>
        </div>
        {(!model.reseller || (model.reseller && !model.isAffiliate)) && (!siteForm?.attr?.accounts?.fb && oauthTokens?.fb) && <>
            <form>
                <div class="form-group">
                    <label for="acct">Account</label>
                    <select id="fb-acct" className="form-control" onChange={(e) => setState(prev => ({...prev, account: {...oauthTokens?.fb?.accounts[e.target.value], key: e.target.value}}))} value={account?.key}>
                        <option></option>
                        {oauthTokens?.fb?.accounts?.map((item, key) => <option key={key} value={key}>{item.name}</option>)}
                    </select>
                </div>
            </form>
        </>}
        {siteForm?.attr?.accounts?.fb && <div>
            {(!model.reseller || (model.reseller && !model.isAffiliate)) && sessionStorage.getItem(OVERRIDE_ID_FB) && <h5 className="alert alert-info">
                Click the Save button to complete the reset token process
            </h5>}
            {(!model.reseller || (model.reseller && !model.isAffiliate)) && <div className={`d-flex justify-content-${isAdmin && siteForm?.attr?.accounts?.fb.refreshRequired ? 'between' : 'end'} mb-3`}>
                {isAdmin && siteForm?.attr?.accounts?.fb.refreshRequired && <div class="alert alert-danger mb-0" role="alert">
                    <strong>Next Alert Date:</strong> {siteForm?.attr?.accounts?.fb.refreshAlertDate}
                </div>}
                <div className="btn-group">
                    {!sessionStorage.getItem(OVERRIDE_ID_FB) && siteForm?.attr?.accounts?.fb?.refreshRequired && <button className="btn btn-lg btn-danger" onClick={() => props.onResetToken("fb", hrefOauth)}>
                        <i class="fas fa-trash-alt"></i> Reset Token
                    </button>}
                    {isAdmin && <button className="btn btn-lg btn-outline-danger" onClick={() => props.onDeleteService("fb")}>
                        <i class="fas fa-trash-alt"></i> Delete
                    </button>}
                </div>
            </div>}
            {isAdmin && <div className="d-flex justify-content-start">
                <i className="fas fa-id-badge mr-1 fa-1-5"></i>
                <strong className="mr-1">Token ID: </strong>
                <h5>{siteForm?.attr?.accounts?.fb?.tokenId}</h5>
            </div>}
            <h3>
                <small class="text-muted">Account:</small> <span id="fbAccountName">{siteForm.attr?.accounts.fb.accountName}</span>
            </h3>          
        </div>}
        {(!model.reseller || (model.reseller && !model.isAffiliate)) && !siteForm?.attr?.accounts?.fb && !oauthTokens?.fb && <AddAccParent>
            <a class="btn btn-success btn-lg" href={hrefOauth}>Add Account</a>
        </AddAccParent>}
    </> 
}

FacebookAds.defaultProps = {
    design: "admin",
    onSelectionUpdated: () => null
}

export default FacebookAds